import React,{Component} from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col
} from 'reactstrap';

import find from 'lodash/find';

import ProgressBarSVG from '../../../shared/components/ProgressBarSVG';

class ThisOrThatResults extends Component {
  render(){
    const { engagementKPIs,engagement } = this.props,
      thisKPI = find(engagementKPIs.answerKPIs, (a) => a.answer === '0') || {answersNum:0},
      thatKPI = find(engagementKPIs.answerKPIs, (a) => a.answer === '1') || {answersNum:0},
      thisPercent = Math.round((thisKPI.answersNum / (thisKPI.answersNum + thatKPI.answersNum)) * 100),
      thatPercent = 100 - thisPercent;

    return (
      <div className='EngagementResults'>
        <Row style={{pageBreakInside:'avoid'}}>
          <Col xs='4'>
            <br />
            <br />
            <h6>This or That</h6>
            <img
              src={engagement.firstImageURL}
              style={{maxWidth:200,borderRadius:10}}
              alt='This'
            />
            <br />
            <img
              src={engagement.secondImageURL}
              style={{maxWidth:200,borderRadius:10}}
              alt='That'
            />
          </Col>
          <Col xs='8'>
            <br />
            <br />
            <br />
            <br />
            <br />
            <ProgressBarSVG
              title={engagement.firstImageTitle || 'This'}
              votes={thisKPI.answersNum}
              totalVotes={thisKPI.answersNum + thatKPI.answersNum}
              displayPercent={thisPercent}
              winner={thisKPI.answersNum > thatKPI.answersNum}
            />
            <br />
            <br />
            <br />
            <br />
            <br />
            <ProgressBarSVG
              title={engagement.secondImageTitle || 'That'}
              votes={thatKPI.answersNum}
              totalVotes={thisKPI.answersNum + thatKPI.answersNum}
              displayPercent={thatPercent}
              winner={thatKPI.answersNum > thisKPI.answersNum}
            />
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <br />
            <br />
          </Col>
        </Row>
      </div>
    )
  }
}

ThisOrThatResults.propTypes = {
  engagement:PropTypes.object.isRequired,
  engagementKPIs:PropTypes.object.isRequired
};

export default ThisOrThatResults;



// WEBPACK FOOTER //
// ./src/routes/CampaignResultsPrint/components/ThisOrThatResults.js